import { useStaticQuery, graphql } from "gatsby";
import _ from "lodash"

export const getPriceStr = ( price ) => {
  let priceStr = '';
  if (price.min && price.max) {
      priceStr = " between " + `£` + addCommas(price.min) + " and " + `£` + addCommas(price.max);
  } else if (price.max) {
      priceStr = " under " + `£` + addCommas(price.max);
  } else if (price.min) {
      priceStr = " over " + `£` + addCommas(price.min);
  }
  return priceStr;
}

function addCommas(num) {
  // console.log('num : ' + num);
  var str = num.toString().split('.');
  // console.log('str, ' + str);
  if (str[0].length >= 4) {
      // add comma every 3 digits before decimal
      str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
  }
  /* Optional formating for decimal places
  if (str[1] && str[1].length >= 4) {
      // add space every 3 digits after decimal
      str[1] = str[1].replace(/(\d{3})/g, '$1 ');
  }*/
  return str.join('.');
}

export const ACTION_TYPES = {
  sales: " for sale in ",
  lettings: " to rent in ",
}

export const ACTION_DESC_TYPES = {
  sales: " for sale ",
  lettings: " to rent ",
}

export const pTypeBase = {
  sales: "/properties-for-sale/",
  lettings: "/properties-to-rent/",
  newhomes_sales: "/new-homes-for-sale/",
  newhomes_rent: "/new-homes-to-rent/",

}

export const toTitleCase = (text) => {
  let _text = text || '';
  // console.log('_text : ' + _text);
  if ( _text ) {
    _text = _text.trim().split(' ');
    // console.log('_text.length : ' + _text.length);
    if ( _text.length > 0 ) {
      _text = _text.map(w => w[0].toUpperCase() + w.substr(1).toLowerCase()).join(' ');
    }
  }
  return _text;
}
function stringContainsNumber(_string) {
  return /\d/.test(_string);
}

// TODO: hard coded details to be removed/replaced with common variables
export const parseSearchUrl = (pType, location, department) => {
  if (location) {
      var query = '';
      var pType_url = pType;
      if(department === "new_developments" && pType === "sales"){
        pType_url = "newhomes_sales";
      }
      if(department === "new_developments" && pType === "lettings"){
        pType_url = "newhomes_rent";
      }
      let pathUri_main = location.split(pTypeBase[pType_url].slice(0, -1))
      var areaVal = ''
      var bedVal = ''
      var minpriceVal = ''
      var maxpriceVal = ''
      var typeVal = ''
      var mustIncludeVal = ''
      if( pathUri_main[1] ) { // following could be regexp
        let pathUri = pathUri_main[1].split('/');
        
        //lets loop
        for(let vi = 1; vi <= pathUri.length; vi++ ) {
          // check for area
          if( typeof pathUri[vi] === "undefined" ) {continue;}
          // for-sale
          if ( pathUri[vi].indexOf("for-sale") >= 0 ) {
            // its area
            pType = 'sales';
          }
          if ( pathUri[vi].indexOf("to-rent") >= 0 ) {
            // its area
            pType = 'lettings';
          }
          // if ( pathUri[vi].indexOf("in-") == 0 ) {
          //   // its area
          //   areaVal = pathUri[vi].replace("in-","").replace("-"," ");
          // }
          if (pathUri && pathUri[1] && pathUri[1]!= "") {
            // its area
            areaVal = pathUri[1]
          }
          if ( pathUri[vi].indexOf("-and-more-") >= 0 ) {
            // its bedrooms
            bedVal = pathUri[vi].replace("-and-more-bedrooms","")
          }
          if ( pathUri[vi].indexOf("studio") >= 0 ) {
            // its studio bedroom
            bedVal = 0
          }
          if ( pathUri[vi].indexOf("between-") >= 0 || 
               pathUri[vi].indexOf("over-") >= 0 || 
               pathUri[vi].indexOf("under-") >= 0
             ) {
            // its price
            let priceFilt1 = pathUri[vi].split('over-');
            if( priceFilt1[1] ) {
              minpriceVal = priceFilt1[1]
            }
            let priceFilt2 = pathUri[vi].split('under-');
            if( priceFilt2[1] ) {
              maxpriceVal = priceFilt2[1]
            }
            let priceFilt3 = pathUri[vi].split('between-');
            if( priceFilt3[1] ) {
              let priceFilt4 = priceFilt3[1].split('-and-');
              minpriceVal = priceFilt4[0]
              maxpriceVal = priceFilt4[1]
            }
          }
          // Must Include
          if (pathUri[vi].indexOf("with-") >= 0) {
            var mustIncludeArrfilt = pathUri[vi].replace("with-", "")
            mustIncludeVal = mustIncludeArrfilt.split("-and-")
          }
          // let priceFilt5 = pathUri[vi].split('type-');
          // if( priceFilt5[1] ) {
          //   typeVal = priceFilt5[1]
          // }
          
          if (pathUri && pathUri[2] && !stringContainsNumber(pathUri[2]) && pathUri[2]!= "" && pathUri[2]!= "sortby-price-desc" && pathUri[2]!= "sortby-price-asc" && pathUri[2]!= "sortby-most-recent") {
            typeVal = pathUri[2]
          }
          //console.log('typeVal',pathUri)
        }
      }

    // If no area send default to set default loaction
    // We could send defaut location
    if (!areaVal || areaVal === 'undefined') {
        areaVal = "Essex and Kent"; // TODO
    }

    var areaAlias = areaVal.replace(' ', '-');

    return {
      department: department,
      pType: pType,
      areas: areaVal,
      areas_alias: areaAlias,
      bedrooms: bedVal,
      type: typeVal,
      mustInclude: mustIncludeVal,
      price: {
        min: minpriceVal,
        max: maxpriceVal,
      },
      extra: {
        bedPlus: false,
        areasTitleCase: true
      }
    }
  }
}

// TODO: hard coded details to be removed/replaced with common variables
export const savedSearchParams = (params) => {
  const {areas, bedrooms, pType, type, price, mustInclude} = params;

  return {
    department: "residential",
    searchType: pType,
    areas: areas,
    bedroom: bedrooms,
    minPrice:  price.min,
    maxPrice:  price.max,
    building: type,
    must_Include: mustInclude,
  }
}


// TODO: hard coded details to be removed/replaced with common variables
const capitalize = (s) => {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}

export const propertyH1 = (params) => {
  // console.log('params : ' + params);

  const {areas, bedrooms, pType, type, price, extra, mustInclude, department} = params;
  // console.log('areas : ' + areas);

  let h1 = "";
  let building = "";

  if ('commercial' === department) { // TODO
    // Commercial Property [action] in [default search area] for Sale and Rent
    building = "Commercial ";

    if (type)
      building += ` ${type} `;
    else
      building += ` Property `;

    h1 += `${building} in `;

    if (areas) {
      h1 += areas;
    }

    h1 += ` for sale and rent`;

  } else {
    //console.log('departmenttyp', department, params)
    let building = "Properties";
    if (bedrooms) {
      building = "properties";
    }
     

    if (department === "new_developments") {
      building = "New Homes";

      if (bedrooms){ building = "new homes"; }
      
    }

    
    
    if (type) {
      building = ` ${type}s`;
      if (department === "new_developments") {
        building = 'New Homes '+ toTitleCase(type);
      }
    } else {
      building = ` Properties `;
      if (department === "new_developments") {
        building = ` New Homes `;
      }
    }
    


    h1 += toTitleCase(building);
    h1 += ACTION_TYPES[pType];

    if (areas) {
      let _areas = areas;
      _areas = _areas.replace(/-/g," ");
      _areas = decodeURIComponent(_areas);
      _areas = extra.areasTitleCase ? toTitleCase(_areas) : _areas;
      h1 += _areas.replace("north","North").replace("road","Road")
    }
    if (bedrooms) {
      let bedPlus = extra.bedPlus ? '+' : '+';
      h1 += ' with more than '+bedrooms+' bedrooms'
    }
    if ( price && (price.min || price.max) )  {
      h1 += getPriceStr(price);
    }

    if ( mustInclude && mustInclude ) {
      h1 += " with "+mustInclude.join('-and-')
    }
  }

  // console.log("H1 title => ", h1);
  return h1;
}


export const propertyDesc = (params) => {
  // console.log('params : ' + params);

  const {areas, bedrooms, pType, type, price, extra, mustInclude, department} = params;
  // console.log('areas : ' + areas);

  let h1 = "";
  let building = "";

  if ('commercial' === department) { // TODO
    // Commercial Property [action] in [default search area] for Sale and Rent
    building = "Commercial ";

    if (type)
      building += ` ${type} `;
    else
      building += ` Property `;

    h1 += `${building} in `;

    if (areas) {
      h1 += areas;
    }

    h1 += ` for sale and rent`;

  } else {
    //console.log('departmenttyp', department, params)
    let building = "Properties";
    if (bedrooms) {
      building = "properties";
    }
     

    if (department === "new_developments") {
      building = "New Homes";

      if (bedrooms){ building = "new homes"; }
      
    }

    
    
    if (type) {
      building = ` ${type.toLowerCase()}s`;
      if (department === "new_developments") {
        building = 'New Homes '+ toTitleCase(type);
      }
    } else {
      building = ` Properties `;
      if (department === "new_developments") {
        building = ` New Homes `;
      }
    }
    


    h1 += building;
    h1 += ACTION_TYPES[pType];

    if (areas) {
      let _areas = areas;
      _areas = _areas.replace(/-/g," ");
      _areas = decodeURIComponent(_areas);
      _areas = extra.areasTitleCase ? toTitleCase(_areas) : _areas;
      h1 += _areas.replace("north","North").replace("road","Road")
    }
    if (bedrooms) {
      let bedPlus = extra.bedPlus ? '+' : '+';
      h1 += ' with more than '+bedrooms+' bedrooms'
    }
    if ( price && (price.min || price.max) )  {
      h1 += getPriceStr(price);
    }

    if ( mustInclude && mustInclude ) {
      h1 += " with "+mustInclude.join('-and-')
    }
  }

  // console.log("H1 title => ", h1);
  return h1;
}


//Branch Postcode Areas
export const getBranchPostcode = (area) => {
  let postAreaCodes = {
    "basildon": ["SS13", "SS14", "SS15", "SS16", "SS17"],
    "wickford": ["SS11", "SS12", "CM11", "SS6"],
    "brentwood": ["CM13", "CM14", "CM11", "CM12"],
    "ongar": ["CM4", "CM5", "CM16", "CM17", "IG4", "IG5", "IG6", "IG7", "IG8", "IG9", "IG10", "E18", "E17", "E4", "E9"],
    "chelmsford": ["CM1", "CM2", "CM3", "CM8"],
    "south-woodham": ["CM0", "CM3"],
    "gravesend": ["DA11", "DA12", "DA3", "DA10", "DA9", "ME2", "ME3"],
    "dagenham": ["RM6", "RM8", "RM9", "RM10", "IG1", "IG5", "IG11", "E3", "E6", "E7", "E12", "E13", "E15", "E16", "E20"],
    "hornchurch": ["RM11", "RM12", "RM13"],
    "romford": ["RM1", "RM2", "RM3", "RM4", "RM5", "RM6", "RM7"],
    "upminster": ["RM14", "RM15", "RM16", "RM17", "RM18", "RM19", "RM20"],
    "loughton": ["IG6", "IG7", "IG8", "IG9", "IG10", "E4", "E10", "E11", "E17", "CM16"],
  }
  if(postAreaCodes[area]){
    return postAreaCodes[area]
  }else{
    return null;
  }
}